import React, { useState, useEffect } from 'react';
import { Modal, Input, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const AddCategoryModal = ({ visible, onClose, onSuccess, editData, onDelete }) => {
  const [categoryName, setCategoryName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [confirmVisible, setConfirmVisible] = useState(false);

  const isEdit = !!editData;

  // pre-fill when editing
  useEffect(() => {
    if (editData) {
      setCategoryName(editData?.categoryName || '');
    } else {
      setCategoryName('');
    }
    setError('');
  }, [editData, visible]);

  const handleClose = () => {
    setCategoryName('');
    setError('');
    onClose();
  };

  const handleSubmit = async () => {
    if (!categoryName?.trim()) {
      setError('Service Category Name is required.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      await onSuccess(categoryName?.trim(), isEdit ? editData.categoryId : 0);
      setCategoryName('');
    } catch (err) {
      setError('Failed to save category. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <span style={{ fontSize: 16, color: '#474747', fontWeight: "bold" }}>
          {isEdit ? 'Edit Category' : 'Add Category'}
        </span>
      }
      visible={visible}
      onCancel={handleClose}
      footer={null}
      centered
      destroyOnClose
      className="ag-modal"
      bodyStyle={{ padding: '20px 28px 28px', borderTop:"1px solid #bfbfbf" }}
    >
      {/* Label */}
      <div style={{ marginBottom: 6 }}>
        <label style={{ fontSize: 13, color: '#333' }}>
          Category Name <span style={{ color: '#720C20' }}>*</span>
        </label>
      </div>

      {/* Input */}
      <Input
        placeholder="e.g., HealthCare Role"
        value={categoryName}
        onChange={(e) => {
          setCategoryName(e.target.value);
          if (error) setError('');
        }}
        onPressEnter={handleSubmit}
        style={{
          borderRadius: 2,
          borderColor: error ? '#ff4d4f' : '#720C20',
          height: 40,
        }}
      />
      {error && (
        <p style={{ color: '#ff4d4f', fontSize: 12, marginTop: 4, marginBottom: 0 }}>
          {error}
        </p>
      )}

      {/* Footer buttons */}
      <div style={{ display: 'flex', justifyContent: isEdit ? 'space-between' : 'flex-end', alignItems: 'center', gap: 10, marginTop: 28 }}>
        {isEdit && onDelete && (
          <Button
            danger
            icon={<DeleteOutlined color='rgb(114, 12, 32)' />}
            onClick={() => setConfirmVisible(true)}
            disabled={loading}
            style={{
              borderRadius: 2,
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
              // gap: 4,
              borderColor: "rgb(114, 12, 32)",
              color: "rgb(114, 12, 32)"
            }}
          >
            Delete
          </Button>
        )}
        <div style={{ display: 'flex', gap: 10 }}>
          <Button
            onClick={handleClose}
            disabled={loading}
            style={{
              borderColor: '#720C20',
              color: '#720C20',
              borderRadius: 2,
              fontWeight: 500,
            }}
          >
            Cancel
          </Button>
          <Button
            loading={loading}
            onClick={handleSubmit}
            style={{
              backgroundColor: '#720C20',
              borderColor: '#720C20',
              color: '#fff',
              borderRadius: 2,
              fontWeight: 500,
            }}
          >
            {isEdit ? 'Update Category' : 'Add Category'}
          </Button>
        </div>
      </div>

      {/* Delete confirmation */}
      <Modal
        visible={confirmVisible}
        onCancel={() => setConfirmVisible(false)}
        footer={null}
        centered
        width={420}
        zIndex={1200}
        closable
        className="ag-modal"
        bodyStyle={{ padding: '28px 28px 20px' }}
      >
        <p style={{ fontSize: 15, color: '#333', marginBottom: 20, textAlign: 'center' }}>
          Are you sure you want to delete <strong>{editData?.categoryName}</strong>?
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
          <Button onClick={() => setConfirmVisible(false)} style={{ minWidth: 100, height: 36, borderRadius: 4, borderColor: '#720C20', color: '#720C20' }}>Cancel</Button>
          <Button
            onClick={() => { setConfirmVisible(false); onDelete(editData.categoryId); }}
            style={{ minWidth: 100, height: 36, borderRadius: 4, backgroundColor: '#720C20', borderColor: '#720C20', color: '#fff' }}
          >Delete</Button>
        </div>
      </Modal>
    </Modal>
  );
};

export default AddCategoryModal;
